module.exports = __webpack_public_path__ + "img/0-87.1492ec5b.jpg";